import styled from "styled-components";
import { SectionContent } from "../../styles/global.syles";

export const FooterContent = styled(SectionContent)`
	width: 88% !important;
	max-width: 1320px;
	margin: auto;

	.footer-flex {
		display: flex;
		justify-content: space-between;
		align-items: center;
		gap: 30px;

		@media screen and (max-width: 991px) {
			flex-direction: column;
			justify-content: flex-start;
			align-items: flex-start;
			gap: 25px;
		}
	}

	.logo {
		flex-shrink: 0;
	}

	.info-flex {
		display: flex;
		flex-wrap: wrap;
		justify-content: flex-end;
		align-items: flex-start;
		gap: 32px;

		@media screen and (max-width: 991px) {
			justify-content: flex-start;
			gap: 24px;
		}

		@media screen and (max-width: 480px) {
			flex-direction: column;
			gap: 18px;
		}
	}

	.info {
		min-width: fit-content;
	}

	.info-title {
		color: #06240a;
		text-transform: uppercase;
		margin-bottom: 8px;
		font-weight: 700;
		font-size: 13px;
		letter-spacing: 0.5px;
	}

	.info-des {
		font-size: 15px;
		font-weight: 500;
		color: #333333;
		white-space: nowrap;

		@media screen and (max-width: 480px) {
			white-space: normal;
			word-break: break-word;
		}

		a {
			color: #333333;
			text-decoration: none;
			white-space: nowrap;
			transition: color 0.2s;

			@media screen and (max-width: 480px) {
				white-space: normal;
			}

			&:hover {
				color: #2806f9;
			}
		}
	}

	.footer-social-icon {
		width: 34px;
		height: 34px;
		border-radius: 50%;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		background: #ffffff;
		color: #06240a;
		font-size: 16px;
		box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
		transition: all 0.25s ease;
		text-decoration: none;

		&.tiktok:hover {
			background: #000000;
			color: #ffffff;
			transform: translateY(-2px);
		}

		&.youtube:hover {
			background: #ff0000;
			color: #ffffff;
			transform: translateY(-2px);
		}
	}
`;

export const DividerAndCopy = styled.div`
	.divider {
		width: 100%;
		height: 1px;
		margin-top: 40px;
		background-color: #e2e8f5;
	}

	.copyright {
		color: #63708a;
		font-size: 13px;
		margin: auto;
		text-align: center;
		padding: 20px;
	}
`;
